import { render, staticRenderFns } from "./OurStory.vue?vue&type=template&id=70f5f83e&scoped=true"
import script from "./OurStory.vue?vue&type=script&lang=js"
export * from "./OurStory.vue?vue&type=script&lang=js"
import style0 from "./OurStory.vue?vue&type=style&index=0&id=70f5f83e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5f83e",
  null
  
)

export default component.exports